import { errorColor } from "./status/error.js";
const error = (mode)=>{
    const color = errorColor(mode);
    return {
        main: color.main,
        light: 'light' === mode ? color.lowContrast : color.highContrast,
        dark: 'light' === mode ? color.highContrast : color.lowContrast
    };
};
export { error };

//# sourceMappingURL=error.js.map